<template>
  <div>
    <div
        class="modal align-items-center justify-content-center"
        tabindex="-1"
        :class="{ 'd-flex': showModal === true }"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">{{ translate('No File Found') }}</div>
            <button type="button" class="close" @click="submit('auto')" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>{{ translate(bodyText) }}</p>
          </div>
          <div class="modal-footer justify-content-between align-items-end">
            <div class="d-flex flex-column">
              <button type="button" class="btn btn-secondary" @click="submit('auto')">
                <i class="fa fa-times"></i> {{ translate('Close') }}
              </button>
            </div>

            <div class="d-flex align-items-stretch flex-column">
              <button
                  v-for="(button, idx) in buttons"
                  type="button"
                  class="btn btn-success"
                  :class="{ 'm-t-5': idx > 0 }"
                  @click="submit(button.downloadEngine)"
              >
                <i :class="button.icon"></i> {{ translate(button.text) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-backdrop fade show" v-if="showModal"></div>
  </div>
</template>

<script>
import {translate} from '../../../helper/translate';
import TransFilter from "./mixins/TransFilter.vue";

export default {
  name: 'downloadengine',
  props: {
    callback: {type: Function},
    showModal: {type: Boolean},
  },
  mixins: [TransFilter],
  mounted() {
    this.bodyText = window.htmlDownloaderConfig.bodyText;
    this.buttons = window.htmlDownloaderConfig.buttons;
  },
  methods: {
    submit(engine) {
      this.callback(engine);
    },
  },
  data() {
    return {
      bodyText: 'No file was found at the provided link. What do you want to do?',
      buttons: null,
    };
  },
};
</script>
